<template>
  <v-dialog v-model="openMode" max-width="500px" content-class="delete-dialog">
    <v-card class="delete-card">
      <div class="delete-header">
        <v-icon size="64" color="error" class="delete-icon">mdi-alert-circle</v-icon>
        <h2 class="delete-title">Delete Contact</h2>
        <p class="delete-message">Are you sure you want to delete this contact?</p>
        <p class="delete-details" v-if="item && item.name">
          <strong>{{ item.name }}</strong>
          <span v-if="item.phone"> ({{ item.phone }})</span>
        </p>
      </div>
      
      <v-divider class="mx-4 my-3"></v-divider>
      
      <v-slide-y-transition>
        <div class="progress-container" v-if="progressShow">
          <v-progress-linear
            indeterminate
            color="error"
            height="4"
            class="mb-3"
          ></v-progress-linear>
          <div class="progress-text">Deleting...</div>
        </div>
      </v-slide-y-transition>
      
      <v-card-actions class="delete-actions">
        <v-btn
          text
          color="grey darken-1"
          @click="closeDelete"
          :disabled="progressShow"
          class="cancel-btn"
        >
          Cancel
        </v-btn>
        
        <v-btn
          color="error"
          :loading="progressShow"
          :disabled="progressShow"
          @click="actionConfirmed"
          class="delete-btn"
        >
          <v-icon left>mdi-delete</v-icon>
          Delete
        </v-btn>
      </v-card-actions>
    </v-card>

    <SnackBar 
      v-model="snackbar" 
      :snacbarText="snacbarText" 
      :snackbarColorBt="snackbarColorBt"
    ></SnackBar>
  </v-dialog>
</template>

<script>
import ApiServices from '@/services/api.service'
import SnackBar from '@/components/widgets/snackBar.vue'

export default {
  props: {
    item: Object,
    value: { type: Boolean, default: false },
  },
  components: {
    SnackBar,
  },
  data: () => ({
    progressShow: false,
    snackbar: false,
    snackbarColorBt: "green",
    snacbarText: "",
  }),

  methods: {
    actionConfirmed() {
      this.deleteItem();
    },

    async deleteItem() {
      try {
        this.progressShow = true;
        let token = localStorage.getItem("token");
        const itemsJSON = JSON.stringify({ phone: this.item.phone, id: this.item._id });

        let api = process.env.VUE_APP_BASE_URL + "/subscribes/delete_subscribe";
        const res = await fetch(api, ApiServices.requestOptions("DELETE", itemsJSON, token));
        
        if (res.status >= 400) {
          this.$emit("itemDeleted", "", "Error deleting contact", "red");
        } else if (res.status === 200) {
          this.$emit("itemDeleted", this.item._id, "Contact deleted successfully!", "green");
          this.openMode = false;
        }
      } catch (error) {
        this.$emit("itemDeleted", "", "Error deleting contact", "red");
      } finally {
        this.progressShow = false;
      }
    },
    
    closeDelete() {
      this.openMode = false;
    }
  },
  computed: {
    openMode: {
      get() {
        return this.value
      },
      set(v) {
        return this.$emit('input', v)
      }
    },
  },
}
</script>

<style scoped>
.delete-dialog {
  border-radius: 16px;
}

.delete-card {
  border-radius: 16px;
  overflow: hidden;
  background: linear-gradient(to bottom, #ffffff, #fff5f5);
}

.delete-header {
  padding: 32px 24px 16px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.delete-icon {
  margin-bottom: 16px;
  opacity: 0.9;
}

.delete-title {
  color: #e11d48;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 12px;
}

.delete-message {
  color: #64748b;
  font-size: 16px;
  margin-bottom: 8px;
}

.delete-details {
  background-color: #fee2e2;
  color: #b91c1c;
  padding: 8px 16px;
  border-radius: 8px;
  margin-top: 8px;
  font-size: 16px;
  max-width: 100%;
  word-break: break-word;
}

.progress-container {
  padding: 16px 24px;
  text-align: center;
}

.progress-text {
  font-size: 14px;
  color: #64748b;
  margin-top: 4px;
}

.delete-actions {
  padding: 16px 24px 24px;
  display: flex;
  justify-content: center;
  gap: 16px;
}

.cancel-btn, .delete-btn {
  min-width: 120px;
  text-transform: none;
  font-weight: 500;
  letter-spacing: 0;
  border-radius: 8px;
}

@media (max-width: 600px) {
  .delete-actions {
    flex-direction: column-reverse;
  }
  
  .cancel-btn, .delete-btn {
    width: 100%;
  }
}
</style>